import React from "react";
import { View, Image, TouchableOpacity } from "react-native";

import { CheckBox } from "components";

import { styles } from "./styles";

export const ImageQuestion = props => {
  const { question, selectedOptions, selectOption } = props;
  const { lang, isEnglish } = props;

  const { options, option_selection_count } = question;
  const icon = option_selection_count === 1 ? "circle" : "square";
  const size = styles._checkboxIcon?.fontSize;

  return (
    <View style={styles.container}>
      {options.map(option => {
        const optionProps = {
          iconRight: !isEnglish,
          text: option[lang],
          icon,
          size,
          image: option.image,
          checked: !!selectedOptions[option.virtual_id],
          onPress: () => selectOption(question, option),
        };
        return <ImageOption key={option.virtual_id} {...optionProps} />;
      })}
    </View>
  );
};

const ImageOption = props => {
  return (
    <TouchableOpacity onPress={props.onPress} style={styles.optionContainer}>
      <View style={styles.checkbox}>
        <CheckBox
          {...props}
          styles={{ text: styles._checkboxText, icon: styles._checkboxIcon }}
        />
      </View>
      <Image
        style={styles.image}
        resizeMode="contain"
        source={{ uri: props.image }}
      />
    </TouchableOpacity>
  );
};
